import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ReactNode } from "react";
import { Typography } from "../../components";

export const Accordion = (props: {
  label: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
}) => {
  return (
    <MuiAccordion sx={(theme) => ({
      boxShadow: `0px 4px 12px ${theme.palette.primary.main}60`, 
    })} defaultExpanded={props.defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon color="primary"/>}>
        <Typography>{props.label}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Typography>{props.children}</Typography>
      </AccordionDetails>
    </MuiAccordion>
  );
};
